import React, { useEffect } from 'react';
import { EditorWizardContext } from '../../../hoc/EditorWizard';
import { LocalizationContext } from '../../../hoc/Localization';
import { RouteContext } from '../../../hoc/Route';
import FinishView from './finishView';
import translitString from '../../TranslitString';

const Finish = () => {
  const { createdCourse, createdSchool } = React.useContext(EditorWizardContext);
  const { t, translate } = React.useContext(LocalizationContext);
  const { page, params } = React.useContext(RouteContext);

  useEffect(() => {
    if (window.fbq) {
      window.fbq('trackCustom', 'ResourceCreated', { type: 'wizard' });
    }
  }, []);

  return (
    <FinishView
      createdCourse={createdCourse}
      createdSchool={createdSchool}
      translitString={translitString}
      translate={translate}
      t={t}
      locale={params.locale}
      page={page}
    />
  );
};

export default Finish;
